export const KEY_PATTERN = /^[A-Za-z0-9_]+$/;

export const metricCodeStyles = {
	fontFamily: 'monospace',
	fontWeight: 700,
	color: 'text.primary',
	backgroundColor: 'action.hover',
	borderRadius: 1,
	px: 0.75,
	py: 0.25,
	overflowWrap: 'anywhere'
};

export const RESULT_LABELS = {
	created: 'Created',
	skipped: 'Already registered',
	reactivated: 'Reactivated',
	failed: 'Failed'
};

export const RESULT_COLORS = {
	created: 'success',
	skipped: 'default',
	reactivated: 'success',
	failed: 'error'
};
